import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';

// @ts-ignore
import styles from './Category.module.scss';
import ArticlesList from '../components/ArticlesList/ArticlesList';
import GlobalWrapper from '../Global';
import SidebarMenu from '../components/SidebarMenu/SidebarMenu';

import generateMetaTags from '../utils/generateMetatags';

export default ({ pageContext }) => {
  const { allCategories } = pageContext;
  const { displayName, subCategories, slug } = pageContext.categoryData;

  const title = pageContext.categoryData.displaySubtitle;
  const extraMetaTagsArray = [
    { property: 'og:title', content: title },
    { property: 'twitter:title', content: title },
  ];

  // {/* <GlobalMetaTags /> */}
  return (
    <>
      <Helmet>
        <title>{title}</title>
        {generateMetaTags(extraMetaTagsArray)}
      </Helmet>
      <GlobalWrapper>
        <div className={styles.container}>
          <div className={styles.layout}>
            <div className={styles.sidebarContainer}>
              <div className={styles.breadcrumb}>
                <Link to="/">
                  <span className={styles.link}>Help</span>
                </Link>
                <span className={styles.separator}> › </span>
                <span className={styles.activeCrumb}>{displayName}</span>
              </div>
              <SidebarMenu {...{ allCategories, slug }} />
            </div>
            <div className={styles.articleListContainer}>
              <h1 className={styles.title}>{displayName}</h1>
              <ArticlesList {...{ slug, subCategories }} stylesProp={undefined} />
            </div>
          </div>
        </div>
      </GlobalWrapper>
    </>
  );
};
